module.exports = __webpack_public_path__ + "static/media/img_mausoleo.d5cdd857.jpg";